/** Roster service (T058/T060, US6). upsertPerson callable + an admin-only persons read. */
import { collection, getDocs } from 'firebase/firestore';
import { callable, db } from './firebase';
import type { CallableResult, Person } from '../types/entities';

export const upsertPerson = callable<
  Partial<Person> & { display_name: string; workspace_email: string },
  CallableResult<Person>
>('upsertPerson');

/** Read the Person roster (admin-only per Security Rules). */
export async function listPersons(): Promise<Person[]> {
  const snap = await getDocs(collection(db, 'persons'));
  return snap.docs.map((d) => d.data() as Person);
}
